/**
 * Static copy for default locale (en-US). Used for static pages and UI labels.
 * Add more keys as needed; other locales can be added as de.js, fr.js, etc.
 */
export default {
  nav: {
    categories: 'Categories',
    topSites: 'Top Sites',
    compare: 'Compare',
    submitSite: 'Submit Site',
    about: 'About',
    logIn: 'Log in',
  },
  common: {
    back: 'Back',
    search: 'Search',
    loading: 'Loading…',
    viewSimilarSites: 'View similar sites',
  },
  hero: {
    badge: 'Site Discovery Engine',
    titleA: 'Find websites similar to',
    titleB: 'your favorites.',
    titlePrefix: 'Find websites similar to',
    titleAccent: 'your favorites.',
    subtitle: 'Discover competitors, alternatives, and hidden gems across the entire web with precision similarity scores.',
    placeholder: 'Enter a domain (e.g. stripe.com)',
    inputPlaceholder: 'Enter a domain (e.g. stripe.com)',
    step1Label: 'Enter a Domain',
    step1Desc: 'Type any website URL to start',
    step2Label: 'Get Matches',
    step2Desc: 'Our engine finds similar sites instantly',
    step3Label: 'Compare & Decide',
    step3Desc: 'Analyze and compare alternatives',
    steps: {
      step1Label: 'Enter a Domain',
      step1Desc: 'Type any website URL to start',
      step2Label: 'Get Matches',
      step2Desc: 'Our engine finds similar sites instantly',
      step3Label: 'Compare & Decide',
      step3Desc: 'Analyze and compare alternatives',
    },
  },
  footer: {
    newsletterTitle: 'Stay Updated',
    newsletterDesc: 'Get weekly reports on trending sites and new alternatives.',
    emailPlaceholder: 'your@email.com',
    subscribe: 'Subscribe',
    brandDesc: "Discover the web's hidden connections. Find websites similar to your favorites with precision scoring.",
    explore: 'Explore',
    popular: 'Popular',
    company: 'Company',
    compareSites: 'Compare Sites',
    sitesLike: 'Sites like',
    contact: 'Contact',
    faq: 'FAQ',
    removeYourSite: 'Remove your site',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    rights: 'All rights reserved.',
  },
  notFound: {
    title: 'Oops! Page not found',
    returnHome: 'Return to Home',
  },
  submitPage: {
    ctaTitle: 'Know a great website?',
    ctaDesc: 'Help grow our database by submitting sites you love. It only takes a few seconds.',
    ctaButton: 'Submit a Site',
    pageTitle: 'Submit a Site',
    pageSubtitle: 'Help us grow our database by submitting a website for indexing.',
    successTitle: 'Site Submitted!',
    successReviewPrefix: "We'll review",
    successReviewSuffix: 'and add it to our index shortly.',
    backHome: 'Back to Home',
    domainLabel: 'Domain *',
    domainPlaceholder: 'e.g. example.com',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Brief description of the website',
    categoryLabel: 'Category',
    categorySelect: 'Select a category',
    alternativeTo: 'Alternative to (optional)',
    alternativeNone: 'None — not an alternative',
    emailLabel: 'Your Email',
    emailPlaceholder: 'you@example.com',
    submitButton: 'Submit Site',
    submitFailed: 'Failed to submit site',
    seoTitle: 'Submit a site | CiteMatch',
    seoDesc: 'Submit a website to be indexed on CiteMatch.',
  },
};
